/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Email, Token } from 'features/auth/types'
import { PURGE } from 'redux-persist'

const userSlice = createSlice({
  name: 'user',
  initialState: {
    email: null,
    token: null,
    clientName: '',
    clientId: null,
    clientLogo: null,
    firstName: null,
    lastName: null,
    isAdviceEnabled: false,
    isPremierAdviceEnabled: false,
    isLearningEnabled: false,
    isFinancialCoachingEnabled: false,
    isHelpAndSupportEnabled: false,
    products: [],
    colors: {},
    fonts: [],
    isOnboarding: null,
    navigation: {},
  } as any,
  reducers: {
    setCredentials: (
      state,
      {
        payload: { email, token, isOnboarding },
      }: PayloadAction<{ email: Email | null; token: Token | null, isOnboarding?: boolean | null}>,
    ) => {
      state.email = email
      state.token = token
      state.isOnboarding = isOnboarding;
    },
    setClient: (
      state,
      { payload: { clientId, clientLogo, clientName } }: any,
    ) => {
      state.clientId = clientId
      state.clientName = clientName
      state.clientLogo = clientLogo
    },
    setUserName: (state, { payload: { firstName, lastName } }: any) => {
      state.firstName = firstName
      state.lastName = lastName
    },
    clearCredentials: (state) => {
      state.clientName = userSlice.getInitialState().clientName
      state.email = userSlice.getInitialState().email
      state.token = userSlice.getInitialState().token
      state.isOnboarding = userSlice.getInitialState().isOnboarding
      state.colors = userSlice.getInitialState().colors
      state.fonts = userSlice.getInitialState().fonts
      state.products = userSlice.getInitialState().products
      state.navigation = userSlice.getInitialState().navigation
    },
    setProducts: (
      state,
      {
        payload: {
          isAdviceEnabled,
          isPremierAdviceEnabled,
          isLearningEnabled,
          isFinancialCoachingEnabled,
          isHelpAndSupportEnabled,
          products,
          colors,
          fonts,
          homePages,
          navigation,
        },
      }: any,
    ) => {
      state.isAdviceEnabled = isAdviceEnabled
      state.isPremierAdviceEnabled = isPremierAdviceEnabled
      state.isLearningEnabled = isLearningEnabled
      state.isFinancialCoachingEnabled = isFinancialCoachingEnabled
      state.isHelpAndSupportEnabled = isHelpAndSupportEnabled
      state.products = products
      state.colors = colors
      state.fonts = fonts
      state.homePages = homePages
      state.navigation = navigation
    },
    setRegistration: (
      state,
      {
        payload: { email, code },
      }: PayloadAction<{ email: Email | null; code: string | null }>,
    ) => {
      state.email = email
      state.token = code
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state.email = userSlice.getInitialState().email
      state.token = userSlice.getInitialState().token
      state.clientName = userSlice.getInitialState().clientName
      state.isOnboarding = userSlice.getInitialState().isOnboarding
    })
  },
})

export const {
  setCredentials,
  clearCredentials,
  setClient,
  setUserName,
  setRegistration,
  setProducts,
} = userSlice.actions

export default userSlice.reducer

export const selectCurrentUser = (state: any) => state.auth
